import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import { getLocale } from '@/utils/getLocale';
import { useLanguage } from './useLanguage';

export const useLocale = (): string => {
  const { language } = useLanguage();
  const { country } = useCurrency();
  return getLocale(language, country);
};
